/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EmployeePaymentMethodType {
  ZORRO_PAY = 'ZORRO_PAY',
  COMBINED = 'COMBINED',
  SELF_PAY = 'SELF_PAY',
}
